import React, { useState } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import groceryActions from "../../../redux/groceryList/action";
import { toggleJWTModal } from "../../../redux/authJWT/action";
import { setCheckoutStep, writeGroceryList } from "../../../redux/checkout/action";
import CartItemRow from "./CartItemRow";
import { serverResponse } from "../../../util/fakeServer";
import { getCartTotals } from "../../../helper/vat";

function CartReview(props) {
  const { list } = props.groceryList;
  const { isAuthenticated } = props.authJWT;

  // Il Totale e' sempre l'importo ivato da pagare; con show_vat_breakdown si
  // espone anche lo split imponibile/IVA (calcolato riga per riga, aggiungendo
  // l'IVA ai prezzi netti e scorporandola da quelli ivati).
  const totals = getCartTotals(list);
  const total = totals.total;

  const { ecommerceConfig = {} } = props.checkout || {};
  const minValue = Number(serverResponse.config.grocery_list_min_value) || 0;
  // Soglia minimo d'ordine: si confronta con i prezzi così come sono
  // dichiarati sul volantino (imponibili sui listini netti, ivati sui B2C).
  const belowMin = minValue > 0 && totals.itemsSubtotal < minValue;

  const handleEmptyCart = () => {
    if (window.confirm("Sei sicuro di voler svuotare il carrello?")) {
      props.deleteAll();
    }
  };

  const [proceeding, setProceeding] = useState(false);
  const [proceedError, setProceedError] = useState(null);

  const handleProceed = async () => {
    // Gate guest: se il tenant non permette il guest e non sei loggato -> login.
    // Guardrail: mai forzare il login se allow_login è disattivato (il modale
    // sarebbe un vicolo cieco) -> in quel caso si procede da ospite.
    if (
      ecommerceConfig.loaded &&
      !ecommerceConfig.guestCheckout &&
      !isAuthenticated &&
      serverResponse.config.allow_login
    ) {
      props.toggleJWTModal();
      return;
    }
    // Gate soglia minima d'ordine.
    if (belowMin) {
      setProceedError(`Raggiungi ${minValue}€ per completare l'ordine.`);
      return;
    }
    setProceeding(true);
    setProceedError(null);
    try {
      // Ri-sincronizza la lista (write) col carrello attuale prima di avanzare:
      // l'id_param_url fresco sara' usato al pagamento (create-checkout / confirm-cart).
      await props.writeGroceryList();
      props.setCheckoutStep(2);
    } catch (e) {
      setProceedError("Errore nel salvataggio del carrello. Riprova.");
    } finally {
      setProceeding(false);
    }
  };

  if (!list || list.length === 0) {
    return (
      <div className="co-card">
        <div className="co-empty">
          <div className="co-empty__icon">
            <FontAwesomeIcon icon={faShoppingCart} />
          </div>
          <p className="co-empty__title">Il carrello è vuoto</p>
          <p className="co-empty__text">
            Aggiungi prodotti dal volantino per iniziare.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="co-card">
      <div className="co-card__header">
        <h2 className="co-card__title">Riepilogo carrello</h2>
        <button
          className="up-btn up-btn--danger-outline"
          style={{ fontSize: "0.82rem", padding: "6px 12px" }}
          onClick={handleEmptyCart}
        >
          <FontAwesomeIcon icon={faTrashAlt} style={{ marginRight: 4 }} />
          Svuota carrello
        </button>
      </div>

      <div className="co-cart-items">
        {list.map((item, index) => (
          <CartItemRow key={item.item_id + "-" + (item.variety || index)} item={item} />
        ))}
      </div>

      <div className="co-summary" style={{ marginTop: 16 }}>
        {totals.showBreakdown && (
          <>
            <div className="co-summary__row">
              <span>Imponibile</span>
              <span>€ {totals.itemsTaxable.toFixed(2)}</span>
            </div>
            <div className="co-summary__row">
              <span>IVA</span>
              <span>€ {totals.itemsVat.toFixed(2)}</span>
            </div>
          </>
        )}
        <div className="co-summary__row co-summary__row--total">
          <span>Totale</span>
          <span>€ {total.toFixed(2)}</span>
        </div>
      </div>

      <div className="co-cart-actions">
        {belowMin && (
          <span style={{ color: "#dc3545", fontSize: "0.82rem" }}>
            Raggiungi {minValue}€ per completare l'ordine.
          </span>
        )}
        {proceedError && (
          <span style={{ color: "#dc3545", fontSize: "0.82rem" }}>{proceedError}</span>
        )}
        <button
          className="up-btn up-btn--primary co-cart-actions__cta"
          onClick={handleProceed}
          disabled={proceeding || belowMin}
          style={proceeding || belowMin ? { opacity: 0.6, cursor: "not-allowed" } : {}}
        >
          {proceeding ? "Attendere…" : "Procedi"}
        </button>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  groceryList: state.groceryList,
  authJWT: state.authJWT,
  checkout: state.checkout,
});

export default connect(mapStateToProps, {
  deleteAll: groceryActions.deleteAll,
  toggleJWTModal,
  setCheckoutStep,
  writeGroceryList,
})(CartReview);
